// extracted by mini-css-extract-plugin
export var alternate = "_h-h";
export var black = "_h-3";
export var blue = "_h-d";
export var blueLight = "_h-c";
export var brand = "_h-7";
export var error = "_h-9";
export var gray = "_h-6";
export var grayBlue = "_h-b";
export var iconWrapper = "_h-4";
export var indigo = "_h-e";
export var orange = "_h-g";
export var pink = "_h-f";
export var primary = "_h-0";
export var purple = "_h-8";
export var success = "_h-5";
export var warning = "_h-a";
export var white = "_h-1";
export var whiteSuccess = "_h-2";